import React from 'react'
import "../MensData.js/ProductsTshirts.css";
import p1 from "../assets/t1.jpg";
import p2 from "../assets/t2.jpg";
import p3 from "../assets/t3.jpg";
import p4 from "../assets/t4.jpg";
import p5 from "../assets/t5.jpg";
import p6 from "../assets/t6.jpg";
export default function ProductsTshirts() {

    const productsTshirts = [
  {
    id: 1,
    name: "Model No. MG-25725-5",
    description: "Premium , Modern fit",
    image: p1,
    link: "/products/menstshirt1",
  },
  {
    id: 2,
    name: "Model No. MG-25725-6",
    description: "Premium , Modern fit",
    image: p2,
    link: "/products/menstshirt2",
  },
  {
    id: 3,
    name: "Model No. MG-25725-10",
    description: "Premium , Modern fit",
    image: p3,
    link: "/products/menstshirt3",
  },
  {
    id: 4,
    name: "Model No. MG-25725-17",
    description: "Premium , Modern fit",
    image: p4,
    link: "/products/menstshirt4",
  },
  {
    id: 5,
    name: "Model No. MG-25725-15",
    description: "Premium , Modern fit",
    image: p5,
    link: "/products/menstshirt5",
  },
  {
    id: 6,
    name: "Model No. MG-25725-19",
    description: "Premium , Modern fit",
    image: p6,
    link: "/products/menstshirt6",
  },
 
];
  return (
    <>
       <section className="pt">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men’s T-Shirt</h1>
      <div className="pt__grid">
        {productsTshirts.map((p) => (
          <article key={p.id} className="pt__card">
            <img className="pt__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="pt__name">{p.name}</h3>
            <p className="pt__desc">{p.description}</p>
            <a className="pt__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
